import { Id, toast, ToastOptions } from 'react-toastify'

interface ToastPayload {
  message?: string
  options?: ToastOptions
}

const BottomToastInfo = (msg: string) =>
  toast.info(msg, {
    hideProgressBar: true,
    position: 'bottom-center',
    autoClose: 3000,
  })

const BottomToastError = (msg: string) =>
  toast.error(msg, {
    hideProgressBar: true,
    position: 'bottom-center',
    autoClose: 5000,
  })

export const showSuccessToast = ({ message, options }: ToastPayload) => {
  return toast.success(message, options)
}

export const showErrorToast = ({ message, options }: ToastPayload) => {
  return toast.error(message, options)
}

export const dismissToast = (toastId: Id) => {
  toast.dismiss(toastId)
}

export { BottomToastInfo, BottomToastError }
